import { SearcherNameToId } from "../constants.js";
function buildFinalItems(items) {
    return items.map((item, index)=>({
            radio: {
                label: item.title,
                checked: index === 0,
                name: 'name-radio-button',
                value: item.id
            },
            searcher: {
                name: item.id,
                props: item.searcher
            },
            endpoint: item.endpoint
        }));
}
export function parseSearcherMultiPakMobileProps(props) {
    const { product , items: searchers = []  } = props ?? {};
    const { items: productItems = []  } = product ?? {};
    if (!product && searchers?.length) {
        return buildFinalItems(searchers);
    }
    const finalItems = [];
    for (const [index, productItem] of productItems.entries()){
        const { label , checked =false , name =''  } = productItem || {};
        const { content =''  } = label ?? {};
        const searcher = searchers[index];
        if (!searcher) continue;
        const finalItem = {
            radio: {
                label: content,
                checked,
                name,
                value: SearcherNameToId[searcher.name]
            },
            searcher
        };
        finalItems.push(finalItem);
    }
    return finalItems;
}
export function parseSearcherMultiParkDesktopProps(props) {
    const { product , items  } = props ?? {};
    const { items: productItems = []  } = product ?? {};
    if (items?.length) {
        return buildFinalItems(items);
    }
    const finalItems = [];
    for (const productItem of productItems){
        const { label , checked =false , name ='' , searcher: searcherName  } = productItem || {};
        const { content =''  } = label ?? {};
        if (!searcherName) continue;
        const searcherProps = (props ?? {})?.[searcherName];
        if (!searcherProps) continue;
        const finalItem = {
            radio: {
                label: content,
                checked,
                name,
                value: searcherName
            },
            searcher: {
                name: searcherName,
                props: searcherProps
            }
        };
        finalItems.push(finalItem);
    }
    return finalItems;
}
export function parseSearcherMultiPakProps(isMobile, rootProps) {
    if (!rootProps) return rootProps;
    const { props , data , ...rest } = rootProps;
    const parsedItems = isMobile ? parseSearcherMultiPakMobileProps(props ?? data) : parseSearcherMultiParkDesktopProps(props ?? data);
    return {
        ...rest,
        props: {
            items: parsedItems
        }
    };
}

//# sourceMappingURL=index.js.map